import cn from "classnames";
import Countdown from "react-countdown";
import { ITournamentAlertsState } from "src/store/gameStore/types";
import { useLocale } from "src/providers/LocaleProvider";
import useChangeTheme from "src/hooks/useChangeTheme";
import CloseIcon, {
    closeIconColors,
} from "src/assets/icons/tournaments/closeIcon";
import { GreenButton, ButtonType } from "src/components/buttons/greenButton";
import { TournamentsModal } from "src/store/models";
import { getButtonColor, goTo } from "src/helpers";
import theme from "src/theme";

import { useStyles } from "./styles";

import notificationSound from 'src/sounds/mp3-new/signalFly.mp3';
import { useEffect, useRef, useState } from "react";
import paths from "../../../../../consts/paths";
import { boardRoot } from "../../../../../core/endpoints";
import useStores from "../../../../../hooks/useStores";


interface IRakeBackModal {
    onClose?: () => void;
    timerFunc?: any;
    title: string;
    color?: string | undefined;
    tournamentGame?: string | undefined | null;
    alertAction: TournamentsModal;
    actionFunction?: () => void;
    timer?: number | undefined;
    tournamentAlertsState: ITournamentAlertsState;
    tournamentId: string;
    currentUserId: string;
    timerSeconds?: number;
}

export default function LeagueAlert({
    onClose,
    title,
    color,
    alertAction,
    actionFunction,
    timer,
    timerSeconds 
}: IRakeBackModal) {
    const styles = useStyles();
    const [hasInteracted, setHasInteracted] = useState(() =>
        localStorage.getItem("userInteracted") === "true"
    );

    const appearanceTheme = useChangeTheme();
    const {
        tournaments: {
            userInteraction: { play },
        },
    } = useLocale();

    useEffect(() => {
        const audioRef = document.getElementById('sound_player') as HTMLAudioElement;
        audioRef.volume = 0.1;
    }, []);

    useEffect(() => {
        if (!hasInteracted) return;

        const playSound = () => {
            const audioRef = document.getElementById('sound_player') as HTMLAudioElement;
            audioRef.src = notificationSound;
            audioRef.load();
            audioRef.volume = 0.1;
            audioRef.play().catch(error => {
                console.error('Failed to play sound:', error);
                localStorage.removeItem("userInteracted");
                setHasInteracted(false);
            });
        };

        const timeoutId = setTimeout(playSound, 20);

        return () => clearTimeout(timeoutId);
    }, [hasInteracted]);

    useEffect(() => {
        if (!hasInteracted) return;

        const playSound = () => {
            const audioRef = document.getElementById('sound_player') as HTMLAudioElement;
            audioRef.src = notificationSound;
            audioRef.load();
            audioRef.play().catch(error => {
                console.error('Failed to play sound:', error);
                localStorage.removeItem("userInteracted");
                setHasInteracted(false);
            });
        };

        const timeoutId = setTimeout(playSound, 20);

        return () => clearTimeout(timeoutId);
    }, [hasInteracted]);


    const timerBox = ({ seconds, completed }) => {
        if (completed) {
            actionFunction?.();
            onClose?.();
            return null;
        } else {
            return <p className={cn(styles.timerText)}>{seconds || 0}</p>;
        }
    };

    const timeDelay = timer || 5000;

    if (timer === 0) return null;

    return (
        <div className={cn(styles.rakeBackModalWrapper, color)}>
            <div
                className={cn(
                    styles.rakeBackFlexContainer,
                    appearanceTheme,
                    color
                )}
            >
                <div className={styles.rakeBackModal}>
                    <div className={styles.rakeBackTextWrapper}>
                        <CloseIcon
                            onClick={onClose}
                            fullFillColor={closeIconColors}
                        />
                        <p className={cn(styles.rakeBackText, "message", alertAction,)}>
                            {title}
                        </p>
                        {alertAction === TournamentsModal.CLOSE_OR_PLAY && (
                            <div className={styles.playWithTimerWrapper}>
                                <Countdown
                                    date={timer}
                                    renderer={({ seconds, completed }) => {
                                        if (completed) {
                                            return null;
                                        }
                                    }}
                                />
                            </div>
                        )}{" "}
                        {(alertAction === TournamentsModal.PUSH_TO_GAME ||
                            alertAction ===
                            TournamentsModal.PUSH_TO_MATCH_GAME) && (
                                <Countdown
                                    // date={Date.now() + timeDelay}
                                    date={timeDelay}
                                    renderer={timerBox}
                                />
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
}

